export const SAML_EMAIL_ATTRIBUTE = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';

export enum IDPOptions {
	NONE = 'NONE',
	SAML = 'SAML',
	OIDC = 'OIDC'
}

export interface ISamlIndetityProvider {
    'provider_type': string,
    'provider_name': string,
    'attribute_mapping': {
        'email': string,
    },
    'provider_details': {
        'MetadataURL'?: string,
        'MetadataFile'?: string
    },
    'configuration_name': string
}

export class SamlIndetityProvider {
    private name = '';
    private emailAttribute;
    private metadataUrl = '';
    private metadataFile: unknown = '';
    private configurationName = '';
    constructor(emailAttribute?:string) {
        this.emailAttribute = emailAttribute;
    }

    setMedataURL = (url: string): void => { this.metadataUrl = url; };
    setMedataFile = (file: unknown): void => { this.metadataFile = file; };
    setConfigurationName = (configurationName: string): void => { this.configurationName = configurationName; };
    getData = (): ISamlIndetityProvider => {

        let providerDetails = {};
        if (this.metadataUrl && this.metadataUrl !== '') {
            providerDetails = { 'MetadataURL': this.metadataUrl };
        } else if (this.metadataFile && this.metadataFile !== '') {
            providerDetails = { 'MetadataFile': this.metadataFile };
        }

        return {
            'provider_type': IDPOptions.SAML,
            'provider_name': this.name,
            'attribute_mapping': {
                'email': this.emailAttribute ?? SAML_EMAIL_ATTRIBUTE,
            },
            'provider_details': providerDetails,
            'configuration_name': this.configurationName
        };
    };
}

